
import CommonUtils from "@/common-utils";
import BottomSheets from "@/components/BottomSheets.vue";
import UgcReportForm from "@/components/UgcReportForm.vue";
import axios from "axios";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { BeautyProfileMemberVO } from "../join/vo/join.vo";
import { FollowMemberVO, UgcProfileVO, UgcVO } from "../ugc/vo/ugc.vo";

@Component({
  components: { BottomSheets, UgcReportForm },
})
export default class Profile extends Vue {
  @Prop() targetMemCd!: number;
  @Prop() contentType!: string;

  currentTab = "reviews"; // followers, followings
  currentContent = "images"; // images , follows

  profile = {} as UgcProfileVO; // 프로필
  followers = [] as Array<FollowMemberVO>;
  followings = [] as Array<FollowMemberVO>;
  ugcs = [] as Array<UgcVO>;
  beautyProfileMembers = [] as Array<BeautyProfileMemberVO>;
  dynamicLinksRaw; // 다이나믹링크

  get getFollowersCount() {
    return this.followers.length;
  }

  get getFollowingsCount() {
    return this.followings.length;
  }

  get getUgcsCount() {
    return this.ugcs.length;
  }

  get getFollows() {
    switch (this.currentTab) {
      case "followers":
        return this.followers;
      default:
        return this.followings;
    }
  }

  get noImageUrl (){
    return CommonUtils.isSystemLocale('ko')?'/noimage.jpg':'/noimage.png';
  }
  // 공유 링크
  get sharedUrl(): string {
    return `${process.env.VUE_APP_MAIN_URL}profile/${this.targetMemCd}`;
  }

  get zlinkSharedUrl(): string{
    return `${process.env.VUE_APP_MAIN_URL}zlink?target=profile/${this.targetMemCd}`;
  }
  profileId(item: FollowMemberVO): string {
    console.log(item)
    return item.memId? item.memId : item.memEmail;
  }

  // 탭변경
  @Watch("currentTab")
  onChangeTabs(e) {
    if (e == "followers") {
      this.searchFollowers();
      return;
    }

    this.searchFollowings();
  }

  // (언)팔로우
  follow(profile) {
    const params = { targetCd: profile.memCd, ugcTypeCd: "047003" };
    // 1. 팔로우
    if (profile.isMyFollow == false) {
      // 팔로우 하시겠습니까?
      if (confirm(this.$t("feed.c0002").toString()) == false) {
        return;
      }

      axios.post("/ugc/follow", params).then((r) => {
        return this.followCallback(r);
      });
      return;
    }

    // 2. 언팔로우
    // 언팔로우 하시겠습니까?
    if (confirm(this.$t("feed.c0003").toString()) == false) {
      return;
    }

    axios.delete("/ugc/follow", { params }).then((r) => {
      return this.followCallback(r);
    });
  }

  // 팔로우 콜백
  followCallback(r: any) {
    this.$toast(this.$t("common.a0007")); // 적용되었습니다.
    this.profile.isMyFollow = !this.profile.isMyFollow;
    this.searchFollows(); //팔로우 목록 재검색
  }

  // 팔로워(잉) 둘다 조회
  searchFollows() {
    axios.get(`/ugc/follows/${this.targetMemCd}`).then((r) => {
      this.followers = r.data.followers;
      this.followings = r.data.followings;
    });
  }

  // 팔로워 조회
  searchFollowers() {
    axios.get(`/ugc/followers/${this.targetMemCd}`).then((r) => {
      this.followers = r.data;
    });
  }

  // 팔로잉 조회
  searchFollowings() {
    axios.get(`/ugc/followings/${this.targetMemCd}`).then((r) => {
      this.followings = r.data;
    });
  }

  // 신고하기 콜백
  reportCallback(r: any) {
    BottomSheets.closeAll();

    // 아무작업도 안했을 때
    if (r == null) {
      return;
    }

    // 접수 되었습니다.
    alert(this.$t("review.a0005").toString());

    // 뒤로가기
    this.$router.go(-1);
  }
  // 사용자 신고
  // @param isBlind: 차단임?
  blindMember(isBlind?: boolean) {
    // 선택한 사용자의 게시물이 목록에서 제외됩니다. 진행하시겠습니까?
    if (isBlind && confirm(this.$t("feed.c0001").toString()) == false) {
      return;
    }
    // 047001: 리뷰, 047002: 피드, 047003: 사용자'
    axios.post("/ugc/report", { ugcTypeCd: "047003", targetCd: this.targetMemCd }).then(() => {
      this.profile.isReported = !this.profile.isReported;
      BottomSheets.closeAll();
    });
  }
  // textarea 개행 문자 변경. \n -> <br>
  getConvertedUgcText(text: string) {
    return text.replace(/\n/g, "<br>");
  }
  // SNS 공유
  sharedProductUrlToSns(platform: string) {
    switch (platform) {
      case "kakao": {
        const imageUrl = this.profile.memProfileFileUrl;
        const title = this.profile.profileDesc || ""; 
          (this as any).$kakao.Link.sendDefault({
            objectType: "feed",
            content: {
              title: title,
              description: "집으로 오는 면세쇼핑 지쿠",
              imageUrl: imageUrl,
              link: {
                mobileWebUrl: this.zlinkSharedUrl,
                webUrl: this.zlinkSharedUrl,
              },
            },
            buttons: [
              {
                title: "웹으로 보기",
                link: {
                  mobileWebUrl: this.zlinkSharedUrl,
                  webUrl: this.zlinkSharedUrl,
                },
              },
              {
                title: "앱으로 보기",
                link: {
                  mobileWebUrl: this.zlinkSharedUrl,
      
                },
              },
            ],
          });
        break;
      }
      case "facebook":
        break;
      case "instagram":
        // 공유 안되는 것 같음
        break;
      case "copy": {
        const textarea = document.createElement("textarea");
        textarea.value = this.zlinkSharedUrl;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);

        // 복사되었습니다.
        this.$toast(this.$t("product.a0001"));
        break;
      }
      default:
        break;
    }

    BottomSheets.closeAll();
  }

  openSnsLink(link) {
    window.open(`${link}`);
  }

  // firebase 다이나믹 링크
  // async createDynamicLinks(): Promise<string> {
  //   if (this.dynamicLinksRaw) {
  //     return this.dynamicLinksRaw;
  //   }
  //   return await axios.get("/common/dynamic-links", { params: { link: `${this.sharedUrl}` } }).then((r) => {
  //     this.dynamicLinksRaw = r.data.shortLink;
  //     return r.data.shortLink;
  //   });
  // }

  created() {
    if(`${this.contentType}` == 'talks'){
      this.currentTab = 'talks';
    }

    axios
      .get(`/ugc/profile/${this.targetMemCd}`)
      .then((r) => {
        this.profile = r.data;
        this.followers = r.data.followers;
        this.followings = r.data.followings;
        this.ugcs = r.data.feeds;
        this.beautyProfileMembers = r.data.beautyProfileMembers;
      })
      .catch((r) => {
        this.$router.go(-1);
      });
  }
}
